module.exports = __webpack_public_path__ + "img/image-3.0a563531.png";